import React, { Component } from 'react';

class PanelStart extends Component {

    render() {
        return (
            <div className="quiz__intro" data-points={this.props.points}>
                <div className="quiz__content">
                    <h1 className="quiz__title">{this.props.intro.title}</h1>
                    <p className="quiz__lead">{this.props.intro.text}</p>

                    <div className="quiz__buttons">
                        <button 
                        type="button" 
                        className="quiz__button quiz__button--high quiz__button--big" 
                        onClick={() => this.props.onClick()}>{this.props.intro.button}</button>
                    </div>
                </div>
            </div>
        );
    }
}

export default PanelStart;


// WEBPACK FOOTER //
// ./src/components/PanelStart.js